import { Link } from "react-router-dom";
import { Scan } from "lucide-react";
import { localePath } from "@/config/site";
import { useI18n } from "@/i18n/I18nContext";
import { GooglePlayBadgeLink } from "@/landing/components/GooglePlayBadgeLink";

const footerLinkClass =
  "text-white transition-colors hover:text-[#4CAF50]";

export function Footer() {
  const { messages, locale } = useI18n();
  const foot = messages.footer;

  return (
    <footer className="bg-[#111111] py-12 text-white">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="mb-8 grid gap-8 md:grid-cols-3">
          <div>
            <h3 className="mb-4 text-2xl">
              <Link
                to={localePath(locale)}
                className="inline-flex items-center gap-2 rounded-lg outline-none focus-visible:ring-2 focus-visible:ring-[#4CAF50]/40"
              >
                <Scan className="h-6 w-6 text-[#4CAF50]" />
                WasOK
              </Link>
            </h3>
            <p className="text-gray-400">{foot.tagline}</p>
          </div>

          <div>
            <h4 className="mb-4 text-gray-400">{foot.linksHeading}</h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to={localePath(locale, "/privacy-policy")}
                  className={footerLinkClass}
                >
                  {foot.privacyPolicy}
                </Link>
              </li>
              <li>
                <Link
                  to={localePath(locale, "/terms-of-service")}
                  className={footerLinkClass}
                >
                  {foot.terms}
                </Link>
              </li>
              <li>
                <Link
                  to={localePath(locale, "/faq")}
                  className={footerLinkClass}
                >
                  {foot.linkFaq}
                </Link>
              </li>
              <li>
                <Link
                  to={localePath(locale, "/support")}
                  className={footerLinkClass}
                >
                  {foot.contact}
                </Link>
              </li>
              <li>
                <Link
                  to={localePath(locale, "/licenses")}
                  className={footerLinkClass}
                >
                  {foot.linkLicenses}
                </Link>
              </li>
              <li>
                <Link
                  to={localePath(locale, "/advertising")}
                  className={footerLinkClass}
                >
                  {foot.linkAdvertising}
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="mb-4 text-gray-400">{foot.downloadHeading}</h4>
            <GooglePlayBadgeLink
              locale={locale}
              ariaLabel={messages.hero.googlePlay}
              className="inline-block rounded-md outline-none transition-opacity hover:opacity-90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#4CAF50]"
              imgClassName="h-11 w-auto"
            />
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 text-center text-sm text-gray-400">
          <p>{foot.copyright}</p>
        </div>
      </div>
    </footer>
  );
}
